"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createWatchRequests = exports.authenticatedPutRequest = exports.authenticatedPostRequest = exports.authenticatedGetRequest = exports.authenticatedDeleteRequest = exports.authenticated = void 0;
exports.deleteEffect = deleteEffect;
exports.deleteRequest = deleteRequest;
exports.effectMap = void 0;
exports.getCurrentClubId = getCurrentClubId;
exports.getEffect = getEffect;
exports.getFileEffect = getFileEffect;
exports.getRequest = getRequest;
exports.postEffect = postEffect;
exports.postRequest = postRequest;
exports.prependClubsUrl = prependClubsUrl;
exports.putEffect = putEffect;
exports.putRequest = putRequest;
exports.setPathApiBase = void 0;
require("whatwg-fetch");
var _fp = _interopRequireDefault(require("lodash/fp"));
var _reduxSaga = require("redux-saga");
var _effects = require("redux-saga/effects");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
// import { selectors as authSelectors } from '../reducers/auth'
// import { selectors as clubsSelectors } from '../reducers/clubs'

const authSelectors = {
  getToken: _fp.default.flow(_fp.default.get('auth'), _fp.default.get('token'))
};
const clubsSelectors = {
  getActive: _fp.default.flow(_fp.default.get('router.location.pathname'), _fp.default.split('/'), _fp.default.get(1))
};
let PATH_API_BASE;
const setPathApiBase = p => {
  PATH_API_BASE = p;
};

/**
 * Wrapper around `fetch`.
 *
 * Returns { error } if the `response` is unsuccessful ~ ![200;300)
 * NEVER throws exceptions.
 */
exports.setPathApiBase = setPathApiBase;
function* wrapFetch(url, options) {
  let response = {};
  try {
    response = yield window.fetch(url, options);
  } catch (err) {
    return {
      error: {
        status: 503,
        statusText: 'Service unavailable'
      }
    };
  }
  let json = {};
  if (_fp.default.get(['_bodyBlob', 'type'], response) === 'application/x-md5' || _fp.default.head(_fp.default.get(['headers', 'map', 'content-type'], response)) === 'application/x-md5') {
    try {
      const md5 = yield response.text();
      json = {
        md5
      };
    } catch (err) {
      // eh
    }
  } else {
    try {
      json = yield response.json();
    } catch (err) {
      // eh
    }
  }
  if (response.ok) {
    const token = response.headers.get('X-Auth-Token');
    if (token) {
      return {
        ...json,
        token
      };
    }
    return json;
  }
  if (_fp.default.isEmpty(json)) {
    return {
      error: {
        status: response.status,
        statusText: response.statusText
      }
    };
  }
  return {
    error: {
      status: response.status,
      statusText: response.statusText,
      body: json
    }
  };
}

/**
 * Builds options for the `fetch` function.
 *
 * - Add content type `application/json`
 * - Stringify the `body` if present
 */
const decorateOptions = function () {
  let method = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'get';
  let body = arguments.length > 1 ? arguments[1] : undefined;
  let otherHeaders = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  let loadedAt = arguments.length > 3 ? arguments[3] : undefined;
  let token = arguments.length > 4 ? arguments[4] : undefined;
  let noHeaders = arguments.length > 5 ? arguments[5] : undefined;
  let headers = {
    'Content-Type': 'application/json',
    ...otherHeaders
  };
  if (token) {
    headers['X-Auth-Token'] = token;
  }
  return {
    method,
    headers: noHeaders ? {} : headers,
    ...(body ? {
      body: JSON.stringify(body)
    } : {})
  };
};
function getRequest(url) {
  let {
    body,
    headers,
    loadedAt,
    token,
    noHeaders
  } = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return function* () {
    return yield (0, _effects.call)(wrapFetch, url, decorateOptions('get', body, headers, loadedAt, token, noHeaders));
  }();
}
function postRequest(url) {
  let {
    body,
    headers,
    loadedAt,
    token,
    noHeaders
  } = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return function* () {
    return yield (0, _effects.call)(wrapFetch, url, decorateOptions('post', body, headers, loadedAt, token, noHeaders));
  }();
}
function putRequest(url) {
  let {
    body,
    headers,
    loadedAt,
    token,
    noHeaders
  } = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return function* () {
    return yield (0, _effects.call)(wrapFetch, url, decorateOptions('put', body, headers, loadedAt, token, noHeaders));
  }();
}
function deleteRequest(url) {
  let {
    body,
    headers,
    loadedAt,
    token,
    noHeaders
  } = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return function* () {
    return yield (0, _effects.call)(wrapFetch, url, decorateOptions('delete', body, headers, loadedAt, token, noHeaders));
  }();
}

/**
 * Helper function to build authenticated request functions.
 *
 * @param  {function} asyncRequestFunction - request function
 * @param  {string} token - API token
 * @return {function} request function embedding the token as a header
 */
const authenticated = (asyncRequestFunction, token) => {
  return function subAuthenticated(url) {
    let {
      body,
      headers,
      loadedAt,
      noHeaders
    } = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    return function* () {
      return yield (0, _effects.call)(asyncRequestFunction, url, {
        body,
        headers,
        loadedAt,
        token,
        noHeaders
      });
    }();
  };
};
exports.authenticated = authenticated;
const authenticatedGetRequest = token => authenticated(getRequest, token);
exports.authenticatedGetRequest = authenticatedGetRequest;
const authenticatedPostRequest = token => authenticated(postRequest, token);
exports.authenticatedPostRequest = authenticatedPostRequest;
const authenticatedPutRequest = token => authenticated(putRequest, token);
exports.authenticatedPutRequest = authenticatedPutRequest;
const authenticatedDeleteRequest = token => authenticated(deleteRequest, token);
exports.authenticatedDeleteRequest = authenticatedDeleteRequest;
const effectMap = exports.effectMap = {
  get: getEffectInternal,
  put: putEffectInternal,
  post: postEffectInternal,
  delete: deleteEffectInternal
};
const createHandleRequest = basePath => {
  const decoratePath = url => {
    return _fp.default.startsWith('http', url) ? url : `${basePath}${_fp.default.startsWith('/', url) ? '' : '/'}${url}`;
  };
  return function* handleRequest(networkChannel) {
    while (true) {
      const {
        outputChan,
        request: {
          type,
          authenticated = true,
          url,
          options = {}
        }
      } = yield (0, _effects.take)(networkChannel);

      // Find the corresponding effect to the type of request
      const internalEffect = effectMap[type];

      // If the request is unknown, throw error
      if (!internalEffect) {
        console.warn(`Unknown request method: ${type}`);
        continue;
      }
      const requestEffect = yield (0, _effects.call)(internalEffect, {
        authenticated
      });
      const result = yield (0, _effects.call)(requestEffect, decoratePath(url), options);
      yield (0, _effects.put)(outputChan, result);
      outputChan.close();
    }
  };
};

// scoped channel accessible by watchRequests and requestEffect
let NETWORK_CHANNEL;
const createWatchRequests = basePath => {
  const handleRequest = createHandleRequest(basePath);
  return function* watchRequests() {
    NETWORK_CHANNEL = yield (0, _effects.call)(_reduxSaga.channel, _reduxSaga.buffers.expanding(20));
    for (var i = 0; i < 10; i++) {
      yield (0, _effects.fork)(handleRequest, NETWORK_CHANNEL);
    }
  };
};
exports.createWatchRequests = createWatchRequests;
function* requestEffect(type, request) {
  // request is an object with these keys:
  //
  // - authenticated (bool)
  // - url (string)
  // - options (object)
  //
  const outputChan = (0, _reduxSaga.channel)();
  const requestWithType = {
    ...request,
    type
  };
  yield (0, _effects.put)(NETWORK_CHANNEL, {
    outputChan,
    request: requestWithType
  });
  return outputChan;
}
function* getEffect(request) {
  return yield (0, _effects.call)(requestEffect, 'get', request);
}
function* putEffect(request) {
  return yield (0, _effects.call)(requestEffect, 'put', request);
}
function* postEffect(request) {
  return yield (0, _effects.call)(requestEffect, 'post', request);
}
function* deleteEffect(request) {
  return yield (0, _effects.call)(requestEffect, 'delete', request);
}
function* getFileEffect(request) {
  return yield (0, _effects.call)(requestEffect, 'get/FILE', request);
}

//  ███████╗███████╗███████╗███████╗ ██████╗████████╗███████╗
//  ██╔════╝██╔════╝██╔════╝██╔════╝██╔════╝╚══██╔══╝██╔════╝
//  █████╗  █████╗  █████╗  █████╗  ██║        ██║   ███████╗
//  ██╔══╝  ██╔══╝  ██╔══╝  ██╔══╝  ██║        ██║   ╚════██║
//  ███████╗██║     ██║     ███████╗╚██████╗   ██║   ███████║
//  ╚══════╝╚═╝     ╚═╝     ╚══════╝ ╚═════╝   ╚═╝   ╚══════╝

function* requestEffectInternal(requestFunction) {
  const token = yield (0, _effects.select)(authSelectors.getToken);
  return yield (0, _effects.call)(requestFunction, token);
}
function getEffectInternal() {
  let {
    authenticated = true
  } = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return function* () {
    if (authenticated) {
      return yield (0, _effects.call)(requestEffectInternal, authenticatedGetRequest);
    }
    return getRequest;
  }();
}
function postEffectInternal() {
  let {
    authenticated = true
  } = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return function* () {
    if (authenticated) {
      return yield (0, _effects.call)(requestEffectInternal, authenticatedPostRequest);
    }
    return postRequest;
  }();
}
function putEffectInternal() {
  let {
    authenticated = true
  } = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return function* () {
    if (authenticated) {
      return yield (0, _effects.call)(requestEffectInternal, authenticatedPutRequest);
    }
    return putRequest;
  }();
}
function deleteEffectInternal() {
  let {
    authenticated = true
  } = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return function* () {
    if (authenticated) {
      return yield (0, _effects.call)(requestEffectInternal, authenticatedDeleteRequest);
    }
    return deleteRequest;
  }();
}
function* getCurrentClubId() {
  const path = yield (0, _effects.select)(_fp.default.get('router.location.pathname'));
  let clubId = _fp.default.get(1, _fp.default.split('/', path));
  if (!_fp.default.isInteger(_fp.default.parseInt(10, clubId))) {
    clubId = yield (0, _effects.select)(clubsSelectors.getActive);
  }
  return clubId;
}
function* prependClubsUrl(url, optionalClubId) {
  const clubId = optionalClubId || (yield getCurrentClubId());
  if (url) {
    return `clubs/${clubId}/${url}`;
  }
  return `clubs/${clubId}`;
}